import { r as registerInstance, h, g as getElement } from './index-16dc7dde.js';
import { h as hammer } from './hammer-4fc67034.js';
import { a as isMobile, f as convertToPx, r as roundHalf } from './utils-15ad90ec.js';
import './_commonjsHelpers-ba3f0406.js';
import './request.constants-deb285e0.js';
import './send-33ade633.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';
import './lookups-705fb53e.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

const brandLogosCss = ".brand__logos{display:flex;flex-direction:column;align-items:flex-start;position:absolute;padding-top:9px;width:100%}@media screen and (min-width: 980px){.brand__logos{width:auto;padding:10px}}.brand__logos-image{margin-bottom:12px;width:54px}.brand__logos-image:last-child{margin-bottom:0}@media screen and (min-width: 980px){.brand__logos-image{width:87px}}.energy-logo{width:78px;height:78px}@media screen and (max-width: 979px){.energy-logo{width:54px;height:auto}}.brand__logos-link{z-index:2}";

let BrandLogos = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getLogoUrl(name) {
    if (this[name].absoluteUrl) {
      return this[name].absoluteUrl;
    }
    return this[name].url;
  }
  render() {
    return (h("div", { class: "brand__logos" }, this.pdsLogo && (h("img", { src: this.getLogoUrl('pdsLogo'), class: "brand__logos-image", alt: this.pdsLogo.alt, loading: "lazy" })), this.greenPremiumLogo && (h("img", { src: this.getLogoUrl('greenPremiumLogo'), class: "brand__logos-image", alt: this.greenPremiumLogo.alt, loading: "lazy" })), this.energyStarLogo && (h("a", { href: this.energyStarLogo.externalUrl, target: "_blank", class: "brand__logos-link" }, h("img", { src: this.getLogoUrl('energyStarLogo'), class: "brand__logos-image energy-logo", alt: this.energyStarLogo.alt, loading: "lazy" })))));
  }
  get el() { return getElement(this); }
};
BrandLogos.style = brandLogosCss;

const popupZoomViewerCss = ".zoom-viewer{position:absolute;top:0;width:100%;height:100%;background:#ffffff;display:flex;align-items:center;justify-content:center;overflow:hidden;cursor:zoom-out}:host(:not([dir=\"rtl\"])) .zoom-viewer{left:0}:host([dir=\"rtl\"]) .zoom-viewer{right:0}.zoom-viewer--hidden{display:none}.zoom-viewer__img{position:relative}.zoom-viewer__info{display:none}@media screen and (min-width: 980px){.zoom-viewer__info{display:flex;align-items:center;justify-content:space-evenly;height:40px;border-radius:20px;position:absolute;bottom:12%;font-size:16px;font-weight:normal;color:#9fa0a4;background:#ffffff}:host(:not([dir=\"rtl\"])) .zoom-viewer__info{padding:0 15px 0 10px}:host([dir=\"rtl\"]) .zoom-viewer__info{padding:0 10px 0 15px}}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .zoom-viewer__label{margin-left:5px}:host([dir=\"rtl\"]) .zoom-viewer__label{margin-right:5px}}";

let PopupZoomViewer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.scaleAmount = 1;
    this.imgLeft = 0;
    this.imgTop = 0;
    this.mobile = isMobile();
    this.onImgToZoomClick = (ev) => {
      let offsetX;
      let offsetY;
      this.zoomViewer.classList.remove('zoom-viewer--hidden');
      if (ev.offsetX && ev.offsetY) {
        offsetX = ev.offsetX;
        offsetY = ev.offsetY;
      }
      else {
        const { left, top } = this.mainImgToZoomMobile.getBoundingClientRect();
        (offsetX = ev.srcEvent.clientX - left), (offsetY = ev.srcEvent.clientY - top);
      }
      this.initZoomedImgOffset(offsetX, offsetY);
      this.mousePos = this.getCursorPosition(ev);
    };
    this.render = () => {
      return (h("div", { class: "zoom-viewer zoom-viewer--hidden", ref: (el) => {
          this.zoomViewer = el;
        } }, h("img", { class: "zoom-viewer__img", width: this.srcImgWidth, height: this.srcImgHeight, src: this.selectedImageSrc, alt: this.selectedImageTitle, ref: (el) => (this.zoomedImg = el), loading: "lazy" }), h("div", { class: "zoom-viewer__info" }, h("pes-icon", null, "action_zoom_minus"), h("span", { class: "zoom-viewer__label" }, this.zoomOutLabel))));
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  hideZoomViewer(newValue) {
    if (newValue === false) {
      this.onZoomViewerHide();
    }
  }
  initImgToZoom() {
    var _a;
    if (this.mobile && this.mainImgToZoomMobile) {
      this.imgToZoomHammer = new hammer.Manager(this.mainImgToZoomMobile);
      this.imgToZoomHammer.add(new hammer.Tap({ event: 'doubletap', taps: 2 }));
      this.imgToZoomHammer.add(new hammer.Tap({ event: 'singletap' }));
      this.imgToZoomHammer.get('singletap').requireFailure('doubletap');
      this.imgToZoomHammer.on('doubletap', this.onImgToZoomDoubleTap);
    }
    else {
      (_a = this.imagesToZoom) === null || _a === void 0 ? void 0 : _a.forEach((img) => img.addEventListener('click', this.onImgToZoomClick));
    }
  }
  initZoomViewer() {
    if (this.mobile) {
      this.zoomViewerHammer = new hammer.Manager(this.zoomViewer);
      this.zoomViewerHammer.add(new hammer.Tap({ event: 'doubletap', taps: 2 }));
      this.zoomViewerHammer.add(new hammer.Tap({ event: 'singletap' }));
      this.zoomViewerHammer.get('singletap').requireFailure('doubletap');
      this.zoomViewer.addEventListener('touchmove', this.onZoomViewerMove);
      this.zoomViewer.addEventListener('touchend', this.onZoomViewerTouchEnd);
      this.zoomViewer.addEventListener('touchstart', this.onZoomViewerTouchStart);
      this.zoomViewerHammer.on('doubletap', this.onZoomViewerHide);
    }
    else {
      this.zoomViewer.addEventListener('click', this.onZoomViewerHide);
      this.zoomViewer.addEventListener('mousemove', this.onZoomViewerMove);
    }
  }
  initZoomedImgOffset(offsetX, offsetY) {
    let deltaX = 0;
    let deltaY = 0;
    const imgHalfHeight = Math.round(this.srcImgHeight) / 2;
    const imgHalfWidth = Math.round(this.srcImgWidth) / 2;
    if (this.checkIfImgIsClicked(offsetX, offsetY, imgHalfWidth, imgHalfHeight)) {
      deltaX = imgHalfWidth - offsetX;
      deltaY = imgHalfHeight - offsetY;
    }
    deltaX = this.mobile ? deltaX : deltaX + this.offsetZoomedImgX;
    this.zoomedImg.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${this.scaleAmount})`;
  }
  checkIfImgIsClicked(offsetX, offsetY, imgHalfWidth, imgHalfHeight) {
    return ((offsetX < imgHalfHeight && offsetY < imgHalfWidth)
      || (offsetX > imgHalfHeight && offsetY < imgHalfWidth)
      || (offsetX < imgHalfHeight && offsetY > imgHalfWidth)
      || (offsetX > imgHalfHeight && offsetY > imgHalfWidth));
  }
  onImgToZoomDoubleTap(ev) {
    this.onImgToZoomClick(ev);
  }
  onZoomViewerMove(ev) {
    this.newMousePos = this.getCursorPosition(ev);
    let { deltaX, deltaY } = this.getModifiedDeltaCursorPosition(this.mousePos, this.newMousePos);
    if (this.mobile) {
      deltaX += this.imgLeft;
      deltaY += this.imgTop;
      this.moveImg(deltaX, deltaY);
    }
    else {
      this.moveImg(-deltaX, -deltaY);
    }
    ev.preventDefault();
  }
  onZoomViewerTouchEnd() {
    const { left, top } = this.zoomedImg.style;
    this.imgLeft = +left.substring(0, left.length - 2);
    this.imgTop = +top.substring(0, top.length - 2);
  }
  onZoomViewerTouchStart(ev) {
    this.mousePos = this.getCursorPosition(ev);
  }
  onZoomViewerHide() {
    this.zoomViewer.classList.add('zoom-viewer--hidden');
    this.zoomedImg.removeAttribute('style');
  }
  getCursorPosition(ev) {
    var _a, _b;
    return {
      x: ev.pageX || ((_a = ev.center) === null || _a === void 0 ? void 0 : _a.x) || Math.round(ev.touches[0].screenX),
      y: ev.pageY || ((_b = ev.center) === null || _b === void 0 ? void 0 : _b.y) || Math.round(ev.touches[0].screenY),
    };
  }
  getModifiedDeltaCursorPosition(startPoint, endPoint) {
    const deltaX = endPoint.x - startPoint.x;
    const deltaY = endPoint.y - startPoint.y;
    return { deltaX, deltaY };
  }
  moveImg(x, y) {
    this.zoomedImg.style.left = convertToPx(x);
    this.zoomedImg.style.top = convertToPx(y);
  }
  mainImgToZoomMobileDidChange(newValue) {
    if (this.mobile && newValue) {
      this.initImgToZoom();
    }
  }
  connectedCallback() {
    this.onImgToZoomClick = this.onImgToZoomClick.bind(this);
    this.onImgToZoomDoubleTap = this.onImgToZoomDoubleTap.bind(this);
    this.onZoomViewerMove = this.onZoomViewerMove.bind(this);
    this.onZoomViewerHide = this.onZoomViewerHide.bind(this);
    this.onZoomViewerTouchEnd = this.onZoomViewerTouchEnd.bind(this);
    this.onZoomViewerTouchStart = this.onZoomViewerTouchStart.bind(this);
  }
  componentDidLoad() {
    this.initImgToZoom();
    this.initZoomViewer();
  }
  componentWillRender() {
    if (this.popupOpen) {
      const zoomSize = this.mobile ? this.mobileZoomedImgSize : this.desktopZoomedImgSize;
      this.scaleAmount = roundHalf(zoomSize / this.srcImgHeight);
    }
  }
  disconnectedCallback() {
    var _a, _b, _c;
    if (this.mobile) {
      if (this.zoomViewer) {
        this.zoomViewer.removeEventListener('touchmove', this.onZoomViewerMove);
        this.zoomViewer.removeEventListener('touchend', this.onZoomViewerTouchEnd);
        this.zoomViewer.removeEventListener('touchstart', this.onZoomViewerTouchStart);
      }
      (_a = this.zoomViewerHammer) === null || _a === void 0 ? void 0 : _a.off('doubletap');
      if (this.mainImgToZoomMobile) {
        (_b = this.imgToZoomHammer) === null || _b === void 0 ? void 0 : _b.off('doubletap');
      }
    }
    else {
      if (this.zoomViewer) {
        this.zoomViewer.removeEventListener('click', this.onZoomViewerHide);
        this.zoomViewer.removeEventListener('mousemove', this.onZoomViewerMove);
      }
      (_c = this.imagesToZoom) === null || _c === void 0 ? void 0 : _c.forEach((img) => img.removeEventListener('click', this.onImgToZoomClick));
    }
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "popupOpen": ["hideZoomViewer"],
    "mainImgToZoomMobile": ["mainImgToZoomMobileDidChange"]
  }; }
};
PopupZoomViewer.style = popupZoomViewerCss;

export { BrandLogos as pes_brand_logos, PopupZoomViewer as pes_popup_zoom_viewer };
